import { countryList } from '@config/countries';
export const onboardingStepsKeys = {
  createCompany: 'createCompany',
  createEmployee: 'createEmployee',
  downloadDesktopApp: 'downloadDesktopApp',
};

export const stepNumberMapping = {
  1: onboardingStepsKeys.createCompany,
  2: onboardingStepsKeys.createEmployee,
  3: onboardingStepsKeys.downloadDesktopApp,
};

export const stepNumberForFormMapping = {
  1: 'createCompanyForm',
  2: 'createEmployeeForm',
};
export const onboardingSteps = [
  {
    key: onboardingStepsKeys.createCompany,
    title: 'Company Setup',
    description: 'Set up your company profile',
  },
  {
    key: onboardingStepsKeys.createEmployee,
    title: 'Employees',
    description: 'Invite your department members',
  },
  {
    key: onboardingStepsKeys.downloadDesktopApp,
    title: 'Desktop App',
    description: 'Download the desktop app',
  },
];

export const stepCardConfig = {
  1: {
    title: 'Company Setup',
    subtitle: 'Tell us about your company to continue',
  },
  2: {
    title: 'Add Employees',
    subtitle: 'Invite your department members to get started',
  },
  3: {
    title: 'Desktop App',
    subtitle: 'Download and install the Prodaff desktop app',
  },
};

export const countryDropdownOptions = countryList.map((i) => {
  return {
    label: i.country,
    value: i.country,
  };
});

/** Firebase Storage URLs for onboarding desktop installers (Windows: public exe; macOS: installer script). */
export const desktopAppDownloadUrls = {
  windows: process.env.REACT_APP_DOWNLOAD_URL_WINDOWS || null,
  macos: process.env.REACT_APP_DOWNLOAD_URL_MACOS || null,
  linux: process.env.REACT_APP_DOWNLOAD_URL_LINUX || null,
};

export const initialOnboardingStepsData = {
  createCompanyForm: {
    companyName: '',
    companyLocation: null,
    timezone: null,
    phoneNumber: '',
    startTime: null,
    endTime: null,
  },
  createTeamForm: {
    teamName: '',
  },
  createEmployeeForm: {
    employees: [
      {
        email: '',
        name: '',
        timeZone: '',
        role: '',
        deskId: '',
        employeeId: '',
      },
    ],
  },
};
